import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const paymentMethodsQuery = gql`
  query PaymentMethods($amount: Int!, $currency: PaymentCurrencyType!, $countryCode: String, $channel: PaymentChannel, $locale: String) {
    paymentMethods(amount: $amount, currency: $currency, countryCode: $countryCode, channel: $channel, locale: $locale) {
      type
      name
      brands
    }
  }
`

export const paymentMethodsKey = getQueryNames(paymentMethodsQuery)[0]

export default paymentMethodsQuery
